module.exports = __webpack_public_path__ + "static/img/cho100.5b95fcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cho100.jpg
// module id = z58o
// module chunks = 5 6